cv.SearchBehavior = Marionette.Behavior.extend({
  // you can set default options
  // just like you can in your Backbone Models
  // they will be overriden if you pass in an option with the same key
  defaults: {
    input: "#search_for",
  },

  // behaviors have events that are bound to the views DOM
  events: {},

  collectionEvents: {
    reset: "collectionReset",
    request: "collectionRequest",
    sync: "collectionSync",
  },

  collectionReset: function (collection) {},

  collectionRequest: function (collection) {},

  collectionSync: function (collection) {},

  onShow: function () {
    this.$(this.options.input).val(this.view.collection.params["search"]);

    var typingTimer;
    var isTyping = false;
    this.$(this.options.input).keyup(
      _.bind(function (e) {
        if (this.$(this.options.input).val().length < 3) {
          return false;
        }

        if (isTyping == false) {
          this.$(".search-list").html(cv.Templates["partials/loader"]());
          isTyping = true;
        }

        clearTimeout(typingTimer);
        typingTimer = setTimeout(
          _.bind(function () {
            isTyping = false;
            this.view.collection.params["search"] = this.$(this.options.input).val();
            this.view.collection.fetch({
              reset: true,
            });
          }, this),
          1000
        );
      }, this)
    );
  },
});
